import { Switch, Card, message } from "antd";
import { useState, useEffect } from "react";
import HTTPClient from "../../../utils/HTTPClient";
import { useTranslation } from "react-i18next";

const NotificationsCard = () => {
    const [loading, setLoading] = useState(false);
    const [marketingSwitch, setMarketingSwitch] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        HTTPClient.get("/notifications/marketing")
            .then((response) => {
                setMarketingSwitch(response.data.marketing_notifications);
            })
            .catch((error) => {
                message.error(t("profile.notifications_card.fetch_error"));
            });
    }, []);

    const onChange = (checked) => {
        setLoading(true);
        HTTPClient.post("/notifications/marketing", { marketing_notifications: checked })
            .then((response) => {
                message.success(t("profile.notifications_card.success"));
                setMarketingSwitch(response.data.marketing_notifications);
            })
            .catch((error) => {
                message.error(t("profile.notifications_card.error"));
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const disabled = t("profile.notifications_card.subtitle_disabled");
    const enabled = t("profile.notifications_card.subtitle_enabled");
    return (
        <>
            <Card
                style={{
                    width: "100vw",
                    maxWidth: "100%",
                    minWidth: "wrap-content",
                }}
                title={t("profile.notifications_card.title")}>
                <h4>{marketingSwitch ? enabled : disabled}</h4>
                <Switch loading={loading} onChange={onChange} checked={marketingSwitch} />
            </Card>
        </>
    );
};

export { NotificationsCard };
